import { motion } from "framer-motion";
import { twMerge } from "tailwind-merge";
import { Image } from "components/elements";
import { useParams } from "react-router-dom";

export default function SolutionRadar({ data }) {
  const { pageSlug2, pageSlug3 } = useParams();
  return (
    <div className={twMerge("radar-item")}>
      {data.map((item, index) => (
        <motion.div
          key={item.id}
          className={`item ${item.className}`}
          style={{
            position: "absolute",
            top: `${item.position.top}px`,
            left: `${item.position.left}px`,
            "--hover-width": item.inner?.width ? `${item.inner.width}px` : "auto",
            "--hover-height": item.inner?.height ? `${item.inner.height}px` : "auto",
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 0.1,
            delay:
              pageSlug2 === "city-solution" && pageSlug3 === "smart-system"
                ? 0.1 * item.id
                : 0.2 * item.id,
          }}
          whileHover="hover"
        >
          <motion.div className="radar-box">
            <div className="icon">
              <Image src="radar-icon.svg" className="desktop-icon"></Image>
              <span className="mobile-number">{index + 1}</span>
            </div>
          </motion.div>
          <div className="inner">
            <motion.div className="txt-box">
              <div className="txt">
                <span className="tit">{item.title}</span>
                {item.desc && (
                  <span className="desc" dangerouslySetInnerHTML={{ __html: item.desc }}></span>
                )}
              </div>
            </motion.div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
